import React from "react";
import styles from "../statics/styles/giphy-selecter.scss";
const GiphyEmptyState = ({ t }) => /* @__PURE__ */ React.createElement("div", { className: styles.giphy_empty_state }, /* @__PURE__ */ React.createElement("div", null, t("GiphyPlugin_Search_EmptyState_Title")), /* @__PURE__ */ React.createElement("div", null, t("GiphyPlugin_Search_EmptyState_Text")));
var giphyEmptyState_default = GiphyEmptyState;
export {
  giphyEmptyState_default as default
};
//# sourceMappingURL=giphyEmptyState.js.map
